import { useMemo } from "react";
import moment from "moment-timezone";
import { useFilters } from "../../../../../utils/hooks/useFilters";
import { renderDurationAsFormat } from "../../../../../utils/helpers/date";

export const calculateSections = (sections: any, startDate: any) => {
    const parseDate = (date: any, startDate: any) => (
        typeof date === "number" ? moment.parseZone(startDate).add(date, "seconds") : date
    );

    return sections?.map((section: any) => {
        const start = parseDate(section?.start, startDate);
        const end = parseDate(section?.end, startDate);

        return {
            ...section,
            start,
            end,
            duration: typeof section?.duration === "number"
                ? renderDurationAsFormat(section?.duration, "HH:mm")
                : section?.duration,
        };
    });
};

export const useCalculatedSections = ({
    startTime,
    selectedCellOrEvent,
    defaultSection,
    sections
}: any) => {
    const [{ mode }] = useFilters();
    return useMemo(() => {
        const startDate = startTime || selectedCellOrEvent?.startDate;
        const baseSections = calculateSections(selectedCellOrEvent?.sections, startDate) || sections || [defaultSection];
        let _sections = baseSections;

        if (mode === "day" && selectedCellOrEvent?.isCreating) {
            const lastShift = baseSections?.[baseSections.length - 1];
            if (lastShift) {
                _sections = [
                    ...baseSections,
                    ...calculateSections(selectedCellOrEvent?.sections || [], startDate)
                ];
            }
        }

        return _sections;
    }, [selectedCellOrEvent, startTime, mode, defaultSection, sections]);
};
